class CustomPredictiveSearch extends PredictiveSearch {
    constructor() {
        super();
        subscribe(PUB_SUB_EVENTS.noSearchResult, () => {
            this.getStaticContent(true);
        });
        this.enable = this.dataset.enable;
        this.mobile = window.matchMedia("(max-width: 600px)").matches;
    }

    onFocus() {
        const currentSearchTerm = this.getQuery();

        if (!currentSearchTerm.length) {
            this.getStaticContent();
        }

        if (this.searchTerm !== currentSearchTerm) {
            this.onChange();
        } else if (this.getAttribute('results') === 'true') {
            this.open();
        } else {
            this.getSearchResults(this.searchTerm);
        }
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        });
    }

    onKeyup(event) {
        if (!this.getQuery().length) {
            if (event.code !== 'Tab') {
                this.close(true);
                this.getStaticContent();
            }
        }

        event.preventDefault();

        switch (event.code) {
            case 'ArrowUp':
                this.switchOption('up');
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                this.selectOption();
                break;
        }
    }

    onKeydown(event) {
        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
            event.preventDefault();
        }
    }

    getSearchResults(searchTerm) {
        if (searchTerm === "") {
            this.getStaticContent();
            return;
        }
        super.getSearchResults(searchTerm);
    }

    getStaticContent(noResult = false) {
        if ((this.enable === "desktop" && this.mobile) || (this.enable === "mobile" && !this.mobile)) {
            return;
        }

        const searchTerm = this.getQuery();
        let url = `${routes.root_url}?section_id=static-predictive-search`;

        if (searchTerm.length > 0) {
            url += `&text=on&searchterms=${encodeURIComponent(searchTerm)}`;
        }

        fetch(url, {
            signal: this.abortController.signal,
        })
            .then((response) => {
                if (!response.ok) {
                    const error = new Error(response.status);
                    this.close();
                    throw error;
                }
                return response.text();
            })
            .then((text) => {
                const parsedDocument = new DOMParser().parseFromString(text, 'text/html');
                const resultsElement = parsedDocument.querySelector('#shopify-section-static-predictive-search');

                const resultsMarkup = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('#shopify-section-static-predictive-search').innerHTML;
                this.renderSearchResults(resultsMarkup);

                if (noResult && this.querySelector("#text-not")) {
                    const textNotElement = resultsElement.querySelector('#text-not');
                    this.querySelector("#text-not").innerHTML = textNotElement.innerHTML;

                    const frameSearchElement = document.getElementById('frame-search');
                    if (frameSearchElement) {
                        frameSearchElement.style.display = 'none';
                    }
                } else {
                    this.querySelector("#text-not").innerHTML = "";

                }
            })
            .catch((error) => {
                if (error?.code === 20) {
                    return;
                }
                this.close();
                throw error;
            });
    }

    close(clear) {
        super.close(clear);
    }
  }

  customElements.define('custom-predictive-search', CustomPredictiveSearch);
